import Axios from "axios";
import {
  SET_SALARY_READY_ATTENDANCE_LIST,
  UNSET_SALARY_READY_ATTENDANCE_LIST,
  SET_SALARY_READY_ATTENDANCE_DETAILS,
  UNSET_SALARY_READY_ATTENDANCE_DETAILS,
} from "@/store/mutation-types";
import {
  getSalaryReadyAttendanceList as getSalaryReadyAttendanceListApi,
  getSalaryReadyAttendanceById as getSalaryReadyAttendanceByIdApi,
  saveUpdateSalaryReadyAttendance as saveUpdateSalaryReadyAttendanceApi,
} from "@/store/api";

const state = {
  salaryReadyAttendanceList: [],
  salaryReadyAttendanceDetails: null,
};

const getters = {
  salaryReadyAttendanceList(state) {
    return state.salaryReadyAttendanceList;
  },
  salaryReadyAttendanceDetails(state) {
    return state.salaryReadyAttendanceDetails;
  },
};

const mutations = {
  [SET_SALARY_READY_ATTENDANCE_LIST](state, data) {
    state.salaryReadyAttendanceList = data;
  },
  [UNSET_SALARY_READY_ATTENDANCE_LIST](state) {
    state.salaryReadyAttendanceList = [];
  },
  [SET_SALARY_READY_ATTENDANCE_DETAILS](state, data) {
    state.salaryReadyAttendanceDetails = data;
  },
  [UNSET_SALARY_READY_ATTENDANCE_DETAILS](state) {
    state.salaryReadyAttendanceDetails = null;
  },
};

const actions = {
  getSalaryReadyAttendanceList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getSalaryReadyAttendanceListApi}`, { params: data })
        .then((response) => {
          commit(SET_SALARY_READY_ATTENDANCE_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_SALARY_READY_ATTENDANCE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalaryReadyAttendanceById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getSalaryReadyAttendanceByIdApi}/${id}`)
        .then((response) => {
          commit(SET_SALARY_READY_ATTENDANCE_DETAILS, response.data.data || null);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_SALARY_READY_ATTENDANCE_DETAILS);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveUpdateSalaryReadyAttendance({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSalaryReadyAttendanceApi, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

